import { instance } from './ApiService';
import { AlertClaim, PaginatedData, AlertClaimItem, RawAlertClaimItem } from '../types';
import { Omit } from 'react-router';
import { ALERT_CLAIMS_PATH } from 'services/AlertClaimService';
const urljoin = require('url-join');

const ALERT_CLAIM_ITEMS_PATH = urljoin(ALERT_CLAIMS_PATH, '/items');

function itemsPath(claimId: AlertClaim['id']): string {
    return urljoin(ALERT_CLAIMS_PATH, claimId);
}

function itemPath(itemId: AlertClaimItem['id']): string {
    return urljoin(ALERT_CLAIM_ITEMS_PATH, itemId);
}

async function getItems(claimId: AlertClaim['id']): Promise<AlertClaimItem[]> {
    return (await instance.get<PaginatedData<RawAlertClaimItem>>(itemsPath(claimId)))
        .data.results.map(AlertClaimItem.fromRaw);
}

async function getItem(id: AlertClaim['id']): Promise<AlertClaimItem> {
    return AlertClaimItem.fromRaw((await instance.get<RawAlertClaimItem>(itemPath(id))).data);
}

async function patchItem(
    id: AlertClaimItem['id'],
    changes: Partial<Omit<AlertClaimItem, 'id'>>
): Promise<AlertClaimItem> {
    return AlertClaimItem.fromRaw((
        await instance.patch<RawAlertClaimItem>(
            itemPath(id),
            changes))
        .data);
}

export {
    getItems as getAlertClaimItems,
    getItem as getAlertClaimItem,
    patchItem as updateAlertClaimItem,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/AlertClaimItemService.ts